import axios, { AxiosResponse } from 'axios';

import { env } from '../../../config';
import { UserInfos } from '../types';

export function fetchUserInfo(loginsRT: string[]): Promise<AxiosResponse<UserInfos[]>> {
  return axios.post(`${env.API_URL}/dataraccov2/user-info`, {
    loginsRT
  });
}
